import * as actionTypes from '../actionTypes/lensPackageUpgrade';

export function getLensPackageDetails(orderId, itemId, apiClient) {
  return { type: actionTypes.GET_LENS_PACKAGE_DETAILS, orderId, itemId, apiClient };
}

export function updatePowerType(payload) {
  return { type: actionTypes.UPDATE_POWER_TYPE_LOAD, payload };
}

export function updatePackage(payload, bodyData) {
  return { type: actionTypes.UPDATE_PACKAGE_LOAD, payload, bodyData };
}

export function updatePrescription(payload, bodyData) {
  return { type: actionTypes.UPDATE_PRESCRIPTION_LOAD, payload, bodyData };
}

export function resetUpdateFields() {
  return { type: actionTypes.RESET_UPDATE_FIELDS };
}
